import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import "./barChartBox.scss";

type Props = {
  title: string;
  color: string;
  dataKey: string;
  chartData: object[];
};

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];


const BarChartBox = (props: Props) => {
  return (
    <div className="w-full h-full ">
      <h1 className="mb-5">{props.title}</h1>
      <div className="">
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={props.chartData}>
          <XAxis dataKey={props.xaxisKey} 
            tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
            axisLine={{ stroke: '#EAF0F4' }} 
            style={{
              fontSize: '10px',
              // fontFamily: 'Times New Roman',
            }}
          />
          <YAxis 
            tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
            axisLine={{ stroke: '#EAF0F4' }} 
            style={{
              fontSize: '10px',
              // fontFamily: 'Times New Roman',
            }}
          />
            <Tooltip
              contentStyle={{ background: "#2a3447", borderRadius: "5px" }}
              // labelStyle={{ display: "none" }}
              cursor={{fill:"none"}}
            />
            <Legend />
            <Bar dataKey={props.dataKey} fill={props.color} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BarChartBox;
